import React from 'react';
import { Diamond, Shield, Microscope, Sparkles, Sheet as Teeth, Scale, FlaskConical, HeartPulse } from 'lucide-react';
import './Dto43b.css';

const Dto43b: React.FC = () => {
  return (
    <div className="dto43b">
      {/* Hero Section */}
      <div className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Snow Porcelain Pro</h1>
          <p>New Generation Diamond Crystal Restoration</p>
        </div>
      </div>

      {/* Introduction Section */}
      <section className="intro-section container">
        <div className="intro-content">
          <div className="intro-text">
            <h2>Advanced Dental Restoration</h2>
            <p>
              Snow Porcelain Pro represents a breakthrough in dental restoration technology, 
              addressing severe tooth damage with innovative diamond crystal technology. 
              This advanced solution not only restores functionality but also provides 
              superior protection for your remaining natural teeth.
            </p>
          </div>
          <div className="intro-image">
            <img 
              src="https://images.unsplash.com/photo-1609840114035-3c981b782dfe?auto=format&fit=crop&q=80&w=1500"
              alt="Advanced Dental Technology"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="features-section">
        <div className="container">
          <h2 className="section-title">4 Major Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <Diamond className="feature-icon" />
              <h3>German Authority Partnership</h3>
              <p>
                Exclusive collaboration with VITA, featuring unique ceramic materials 
                enhanced with over 50% diamond content. Yueting is Taiwan's sole 
                authorized partner.
              </p>
            </div>
            <div className="feature-card">
              <Scale className="feature-icon" />
              <h3>Enhanced Strength</h3>
              <p>
                6x harder than traditional braces and glass ceramics, requiring less 
                tooth grinding while providing superior protection.
              </p>
            </div>
            <div className="feature-card">
              <FlaskConical className="feature-icon" />
              <h3>Fluoride Protection</h3>
              <p>
                Unique adhesive technology enables continuous fluoride ion release, 
                preventing decay and fighting acid erosion.
              </p>
            </div>
            <div className="feature-card">
              <Microscope className="feature-icon" />
              <h3>Precision Technology</h3>
              <p>
                High-power microscopic equipment combined with gold-containing precision 
                drills for minimal grinding.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Technology Section */}
      <section className="technology-section container">
        <div className="tech-content">
          <div className="tech-info">
            <h2>Revolutionary Technology</h2>
            <p>
              Snow Porcelain Pro utilizes advanced diamond crystal technology and 
              precision manufacturing processes to deliver exceptional results. Our 
              sophisticated equipment ensures minimal tooth reduction while maximizing 
              protection and durability.
            </p>
            <div className="tech-comparison">
              <div className="comparison-item">
                <h3>Traditional Method</h3>
                <p>Requires significant tooth reduction</p>
              </div>
              <div className="comparison-item highlight">
                <h3>Snow Porcelain Pro</h3>
                <p>Minimal grinding, maximum preservation</p>
              </div>
            </div>
          </div>
          <div className="tech-image">
            <img 
              src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&q=80&w=1500"
              alt="Dental Technology"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2 className="section-title">Key Benefits</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <Shield className="benefit-icon" />
              <h3>Superior Protection</h3>
              <p>
                Advanced fluoride ion technology provides continuous protection against 
                decay and acid erosion.
              </p>
            </div>
            <div className="benefit-card">
              <Teeth className="benefit-icon" />
              <h3>Natural Preservation</h3>
              <p>
                Minimal grinding technique preserves more of your natural tooth structure.
              </p>
            </div>
            <div className="benefit-card">
              <HeartPulse className="benefit-icon" />
              <h3>Long-Term Health</h3>
              <p>
                Comprehensive protection for both restored and surrounding teeth.
              </p>
            </div>
            <div className="benefit-card">
              <Sparkles className="benefit-icon" />
              <h3>Aesthetic Excellence</h3>
              <p>
                Natural-looking results that blend seamlessly with your smile.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dto43b;